import React from 'react'
import { Form, Input, Select } from 'antd';

import { insuredPersonValidationFormRules as rules } from '../../utils/form-rules';

function addStr(str, index, stringToAdd) {
    return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
}


/**
 * 
 * Se usa "documentType" y "document". documentType para expresar el tipo: CUIT,DNI,etc. document para expresar el valor. 
 * Hoy solo se utiliza Cuit.
 * 
 */

const Document = ({ form: { getFieldValue, setFieldsValue } }) => {


    const handleChangeCuit = e => {

        const cuit = getFieldValue('document');
        const { value: input } = e.target;

        if (cuit.charAt(input.length - 1) === "-") {
            const without_dashed = input.slice(0, -1)
            setFieldsValue({ document: without_dashed })
        }

        else {
            if (((cuit.length === 3) || (cuit.length === 12))) {

                const dash_occurences = cuit.split("-").length - 1;

                if (dash_occurences >= 0 & dash_occurences <= 1) {
                    const cuit_dashed = (cuit.length === 3) ?
                        addStr(input, 2, '-') : addStr(input, 11, '-')

                    setFieldsValue({ document: cuit_dashed })
                }
            }
            else setFieldsValue({ document: input })
        }
    }


    return (
        <Form.Item label="Tipo doc">
            <Input.Group compact>
                <Form.Item
                    name="documentType"
                    rules={[...rules.documentType]}
                    initialValue="cuit"
                >
                    <Select size="large">
                        <Select.Option value="cuit">CUIT/CUIL</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    name="document"
                    rules={[...rules.document]}
                    validateTrigger={["onChange", "onBlur"]}
                >
                    <Input
                        maxLength={13}
                        size="large"
                        placeholder="Nro de CUIT/CUIL"
                        onChange={handleChangeCuit} />
                </Form.Item>
            </Input.Group>
        </Form.Item >
    );
}

export default Document;